/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BodyZone,
  CreateBodyZone,
} from '../models/index';
import {
    BodyZoneFromJSON,
    BodyZoneToJSON,
    CreateBodyZoneFromJSON,
    CreateBodyZoneToJSON,
} from '../models/index';

export interface BodyZoneCreateRequest {
    createBodyZone: CreateBodyZone;
}

export interface BodyZoneDeleteRequest {
    bodyZoneId: string;
}

export interface BodyZoneUpdateRequest {
    bodyZone: BodyZone;
}

/**
 * 
 */
export class BodyZoneApi extends runtime.BaseAPI {

    /**
     */
    async bodyZoneCreateRaw(requestParameters: BodyZoneCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BodyZone>> {
        if (requestParameters['createBodyZone'] == null) {
            throw new runtime.RequiredError(
                'createBodyZone',
                'Required parameter "createBodyZone" was null or undefined when calling bodyZoneCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/body-zone`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateBodyZoneToJSON(requestParameters['createBodyZone']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BodyZoneFromJSON(jsonValue));
    }

    /**
     */
    async bodyZoneCreate(requestParameters: BodyZoneCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BodyZone> {
        const response = await this.bodyZoneCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async bodyZoneDeleteRaw(requestParameters: BodyZoneDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['bodyZoneId'] == null) {
            throw new runtime.RequiredError(
                'bodyZoneId',
                'Required parameter "bodyZoneId" was null or undefined when calling bodyZoneDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/body-zone/{bodyZoneId}`.replace(`{${"bodyZoneId"}}`, encodeURIComponent(String(requestParameters['bodyZoneId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async bodyZoneDelete(requestParameters: BodyZoneDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.bodyZoneDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async bodyZoneListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BodyZone>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/body-zone`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BodyZoneFromJSON));
    }

    /**
     */
    async bodyZoneList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BodyZone>> {
        const response = await this.bodyZoneListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async bodyZoneUpdateRaw(requestParameters: BodyZoneUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BodyZone>> {
        if (requestParameters['bodyZone'] == null) {
            throw new runtime.RequiredError(
                'bodyZone',
                'Required parameter "bodyZone" was null or undefined when calling bodyZoneUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/body-zone`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BodyZoneToJSON(requestParameters['bodyZone']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BodyZoneFromJSON(jsonValue));
    }

    /**
     */
    async bodyZoneUpdate(requestParameters: BodyZoneUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BodyZone> {
        const response = await this.bodyZoneUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
